import React from "react";
import {
    imageUrl,
    appUrl,
    contentSiteUrl,
    rootUrl,
    marketPlaceUrl,
    BlogUrl
} from "helpers/ApplicationHelper";
import GA from "lib/ga";
import {connect} from "react-redux";
import I18n from "../../lib/i18n/i18n";
import WorthyApi from "../../lib/api/worthyApi";
import CalendlyHelper from '../../lib/calendly';

export const HeaderItems = [
    {to: `${contentSiteUrl('/how-it-works/')}`, caption: I18n.getString('experts::header::howItWorks')},
    {
        to: '#', caption: I18n.getString('experts::header::explore'), type: 'dropdown',
        subCategories: [
            {to: `${rootUrl('/about/recent-deals/rings')}`, caption: I18n.getString('experts::header::recentlySold')},
            {to: `${contentSiteUrl('/reviews/')}`, caption: I18n.getString('experts::header::reviews')},
            {to: `${appUrl('/learn')}`, caption: I18n.getString('experts::header::learn')},
            {to: `${BlogUrl('/')}`, caption: I18n.getString('experts::header::blog')},
            {to: `${rootUrl('/about/')}`, caption: I18n.getString('experts::header::aboutUs')},
        ]
    },
    {to: `${marketPlaceUrl('/')}`, caption: I18n.getString('experts::header::buyARing'), beta: true},
];

const accountStatus = {
    loggedIn: {
        to: `${appUrl('/items')}`,
        subCategories: [
            {
                caption: I18n.getString('header::menu::titles::myAccount'),
                to: `${appUrl('/items')}`
            },
            {
                caption: I18n.getString('header::menu::titles::logOut'),
                to: `${contentSiteUrl("/")}`
            }
        ]
    },
    signIn: {
        caption: I18n.getString('header::menu::titles::logIn'),
        to: `${appUrl('/signin')}`,
    }
};

class ExpertsHeader extends React.Component {
    constructor(props) {
        super(props);

        this.renderHeaderItems = this.renderHeaderItems.bind(this);
        this.getDropDownMenu = this.getDropDownMenu.bind(this);
        this.getLink = this.getLink.bind(this);
        this.isLoggedIn = this.isLoggedIn.bind(this);
    }

    componentDidMount() {
        CalendlyHelper.loadCalendly();
    }

    componentWillUnmount() {
        CalendlyHelper.removeCalendly();
    }

    getLink(item, isSubItem = false, lastSubItem = false, userId = '') {
        const {caption, to, beta, linkImg} = item;
        let link = to;

        if (
          link && link.includes("refer_a_friend") &&
          this.props.ADO && this.props.ADO.user
        ) {
          const user = this.props.ADO.user;
          link = link.replace("{leadId}", user.lead_id).replace("{userId}", user.id);
        }

        return (
            <li
                key={`experts-header${isSubItem ? '-sub' : ''}-item-${caption.replace(/\s/g, '-')}`}
                className={`d-flex flex-align-center menu-item ${isSubItem ? 'sub-item ' : ''} ${lastSubItem ? "last-item" : ""}`}
                onClick={() => {
                    if(caption === I18n.getString('header::menu::titles::logOut')) {
                        WorthyApi.logOut(userId);
                    }
                    let camelcaseCaption = caption.replace(/\W+(.)/g, function (match, chr) {
                        return chr.toUpperCase();
                    }).replace(/\s/g, '');
                    GA.expertsHeaderLinks(camelcaseCaption);
                }}>
                <a className={`d-flex flex-align-center link ${beta ? 'wide-link' : ''}`} href={link}>
                    {linkImg ? <img className={'sub-menu-icon'} src={imageUrl(linkImg)}/> : null}
                    {caption}
                    {beta ? (
                        <span className="beta-wrapper">
                          <span className="beta-tag">Beta</span>
                      </span>
                    ) : null}
                </a>
            </li>
        );
    }

    getDropDownMenu(to, caption, subCategories, beta) {
        return (
            <li
                key={`experts-header-item-${caption.replace(/\s/g, '-')}`}
                className="d-flex flex-align-center menu-item"
            >
                <a className={`d-flex flex-align-center link ${beta ? 'wide-link' : ''}`} href={to}>
                    {caption}
                    {beta ? (
                        <span className="beta-wrapper">
                        <span className="beta-tag">Beta</span>
                    </span>
                    ) : null}
                </a>


                <ul className="header-sub-categories-container">
                    {subCategories.map((subItem, subItemIndex) => {
                        return this.getLink(subItem, true, subItemIndex === subCategories.length - 1);
                    })}
                </ul>
            </li>
        );
    }

    renderHeaderItems() {
        return HeaderItems.map((item) => {
            const {to, caption, type, subCategories, beta} = item;

            if (type === "dropdown" && subCategories) {
                return this.getDropDownMenu(to, caption, subCategories, beta);
            }

            return this.getLink(item);
        });
    }

    isLoggedIn() {
        return this.props.Session && this.props.Session.isLoggedIn;
    }

    renderAccountStatus() {
        const user = this.props.ADO && this.props.ADO.user;
        const userName = user && user.first_name || '';
        const userData = {
            userId: user && user.id,
            leadId: user && user.lead_id
        };
        const accountStatusMenu = accountStatus[this.isLoggedIn() ? 'loggedIn' : 'signIn'];
        const itemsCount = this.props.itemsCount;
        const {to, subCategories} = accountStatusMenu;

        return this.isLoggedIn() ?
            (
                <React.Fragment>
                    <li
                        key='experts-header-item-account-status'
                        className="d-flex flex-align-center menu-item"
                    >
                        <a className={`d-flex flex-align-center link`} href={to}>
                            {I18n.getString('header::menu::titles::hi', {userName})}
                        </a>


                        <ul className="header-sub-categories-container account-status">
                            {subCategories.map((subItem, subItemIndex) => {
                                if (user && to && to.includes('{')) {
                                    let link = to;
                                    for (let k in userData) {
                                        link = link.replace(`{${k}}`, userData[k]);
                                    }
                                    subItem.to = link;
                                }
                                return this.getLink(subItem, true, subItemIndex === subCategories.length - 1, userData.userId);
                            })}
                        </ul>
                    </li>
                    <li
                        key='experts-header-item-account-status'
                        className="d-flex flex-align-center"
                    >
                        <a className={`d-flex flex-align-center link`} href={appUrl(`/items`)}>
                            <div className='blue-circle'>
                                {itemsCount < 1 ? '' : itemsCount < 9 ? itemsCount : 9}
                                {itemsCount > 9 && <span className='plus'> + </span>}
                            </div>
                        </a>
                    </li>
                </React.Fragment>
            ) : this.getLink(accountStatusMenu);
    }

    render() {
        return (
            <div className="experts-header-container d-flex">
                <div
                    className="logo-container"
                    onClick={() => {
                        window.location.href = contentSiteUrl("/");
                    }}>
                    <img alt="worthy-logo" src={imageUrl("worthyLogoBlack.svg")}/>
                </div>
                <ul className="header-links-container d-flex">
                    {this.renderHeaderItems()}
                    {this.renderAccountStatus()}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = ({LastItem, Session, ADO, ItemsCount}) => {
    return {
        LastItem,
        Session,
        ADO,
        itemsCount: ItemsCount,
    };
};

export default connect(mapStateToProps)(ExpertsHeader);
